import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * Renders a page keyed by its `:id` route param, so moving from one record to another
 * (Back, a link, a typed URL) mounts a fresh instance instead of reusing the previous
 * record's. Without it a save or approve still in flight for the old record finishes in
 * the old closure and refreshes the old record onto the new page, where the next save
 * writes it to the wrong record. The old instance's loaders are dropped on unmount.
 *
 * @param {React.ComponentType} Page
 * @returns {React.ComponentType}
 */
export default function remountOnId(Page) {
  const Keyed = (props) => {
    const { id } = useParams();
    return <Page key={id} {...props} />;
  };
  Keyed.displayName = `RemountOnId(${Page.displayName || Page.name || 'Page'})`;
  return Keyed;
}
